import crypto from 'crypto'

function validatePublicKey(publicKey) {
    let isValid = false;
    try {
        
        crypto.publicEncrypt(publicKey, Buffer.from("jwt-public-key"));
        isValid = true;

    } catch(e) {
        console.log(e)
    } 
    return isValid
}
export default {
  validatePublicKey
}
